import React from "react";
import Box from "@mui/joy/Box";
import Chip from "@mui/joy/Chip";
import List from "@mui/joy/List";
import ListItem from "@mui/joy/ListItem";
import Typography from "@mui/joy/Typography";

/** «Как читать»: термин — пояснение, списком, как в аналитике заявок */
export function HowTo({ items }: { items: Array<[React.ReactNode, React.ReactNode]> }) {
    return (
        <List size="sm" marker="disc">
            {items.map(([term, text], i) => (
                <ListItem key={i}>
                    <Typography level="body-sm">
                        <strong>{term}</strong> — {text}
                    </Typography>
                </ListItem>
            ))}
        </List>
    );
}

/** Переключатели серий графика: нажатие скрывает серию или показывает снова */
export function SeriesToggle({ series, hidden, onToggle }: {
    series: Array<{ dataKey: string; label: string; color: string }>;
    hidden: ReadonlySet<string>;
    onToggle: (dataKey: string) => void;
}) {
    return (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75 }} role="group" aria-label="Показывать на графике">
            {series.map((s) => {
                const isShown = !hidden.has(s.dataKey);
                return (
                    <Chip
                        key={s.dataKey}
                        size="sm"
                        variant={isShown ? "soft" : "outlined"}
                        aria-pressed={isShown}
                        onClick={() => onToggle(s.dataKey)}
                        startDecorator={
                            <Box sx={{ width: 10, height: 10, borderRadius: "50%",
                                bgcolor: isShown ? s.color : "transparent", border: `2px solid ${s.color}` }} />
                        }
                        sx={{ opacity: isShown ? 1 : 0.6 }}
                    >
                        {s.label}
                    </Chip>
                );
            })}
        </Box>
    );
}
